import apiUseCases from "@src/cloud-connect/api";
import { parseAxiosApiError } from "@src/cloud-connect/utils/parse-axios-api-error";
import store from "@src/reducers/store";
import { UploadSupportAttachmentResponse } from "@src/cloud-connect/api/support/post-upload-attachment";

export interface PostUploadSupportAttachmentResult {
  success: boolean;
  data?: UploadSupportAttachmentResponse;
  error?: string;
}

export const postUploadAttachmentUseCase = async (
  formData: FormData,
): Promise<PostUploadSupportAttachmentResult> => {
  try {
    const namespace = store.getState().yourSlice.authContext.customerNamespace;

    const response = await apiUseCases.postUploadAttachment(
      namespace,
      formData,
    );

    return {
      success: true,
      data: response,
    };
  } catch (error) {
    return {
      success: false,
      error: parseAxiosApiError(error, "Failed to upload support attachment.")
        .message,
    };
  }
};
